
import utils from '@/components/tools/utils'

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    maxWidthTooltip () {
      if (this.$vuetify.breakpoint.mobile) {
        return '60vw'
      } else {
        return '40vw'
      }
    },
    oldTargetPrice () {
      if (this.product.auction?.history?.priceReductions?.length === 0) {
        return null
      }
      return this.product.auction.history.priceReductions[0].oldTargetPrice
    },

    targetPriceIsLowerThanOldTargetPrice () {
      if (!this.oldTargetPrice) {
        return false
      }
      return this.product.auction.targetPrice < this.oldTargetPrice
    }

  },
  methods: {
    getPercentageDifference (a, b) {
      return utils.getPercentageDifference(a, b)
    },
    formatCurrency (value) {
      return utils.formatCurrency(value)
    }
  }
}
